export class ClinicDeptModel {
    clinic_dept: string
    clinic_desc: string
    clinic_dept_code: string
    clinic_no: number

    constructor(
        clinic_dept: string,
        clinic_desc: string,
        clinic_dept_code: string,
        clinic_no: number
    ) {
        this.clinic_dept = clinic_dept
        this.clinic_desc = clinic_desc
        this.clinic_dept_code = clinic_dept_code
        this.clinic_no = clinic_no
    }
}